module.exports = __webpack_public_path__ + "static/about1-dddb08cc2b14f220c38fefc419b3847e.png";